import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Fires server-confirmed OpenAI Ads conversions in the browser with the SAME event_id used server-side (dedup).
const flush = async () => {
  try {
    const { data } = await api.get("/ads/conversions/pending");
    for (const ev of data.events || []) {
      if (window.oaiq) {
        window.oaiq("measure", ev.type, {
          type: "contents", amount: ev.amount, currency: ev.currency,
          contents: [{ id: "corsando_monthly", name: "Abbonamento Corsando mensile", content_type: "plan", quantity: 1 }],
        }, { event_id: ev.event_id });
      }
      window.gtag?.("event", "purchase", { transaction_id: ev.event_id, value: ev.amount / 100, currency: ev.currency });
      await api.post(`/ads/conversions/${ev.event_id}/ack`);
    }
  } catch (e) { /* not logged in or offline */ }
};

export const AdsTracking = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (!user) return;
    flush();
    const h = () => flush();
    window.addEventListener("corsando:payment-success", h);
    return () => window.removeEventListener("corsando:payment-success", h);
  }, [user]);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    window.gtag?.("event", "page_view", { page_path: pathname, page_location: window.location.href, page_title: document.title });
  }, [pathname]);
  return null;
};
